import React from "react";

const Day = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M25.103 18a7.104 7.104 0 1 1-14.208 0 7.104 7.104 0 0 1 14.208 0ZM18 2c.99 0 1.792.802 1.792 1.792v4.44a1.792 1.792 0 0 1-3.584 0v-4.44C16.208 2.802 17.01 2 18 2ZM18 25.976c.99 0 1.792.802 1.792 1.792v4.44a1.792 1.792 0 1 1-3.584 0v-4.44c0-.99.802-1.792 1.792-1.792ZM25.976 18c0-.99.802-1.793 1.792-1.793h4.44a1.792 1.792 0 0 1 0 3.584h-4.44c-.99 0-1.792-.802-1.792-1.791ZM2 18c0-.99.802-1.793 1.792-1.793h4.44a1.792 1.792 0 0 1 0 3.584h-4.44C2.802 19.791 2 18.99 2 18ZM29.314 6.686c.7.7.7 1.835 0 2.534l-3.14 3.14a1.792 1.792 0 1 1-2.534-2.535l3.14-3.139c.7-.7 1.834-.7 2.534 0ZM12.36 23.639c.7.7.7 1.834 0 2.534l-3.14 3.14a1.792 1.792 0 0 1-2.534-2.534l3.14-3.14c.7-.7 1.834-.7 2.534 0ZM23.64 23.64c.7-.7 1.834-.7 2.534 0l3.14 3.14a1.792 1.792 0 0 1-2.535 2.534l-3.14-3.14c-.7-.7-.7-1.834 0-2.534ZM6.686 6.686c.7-.7 1.835-.7 2.535 0l3.139 3.14a1.792 1.792 0 0 1-2.534 2.534l-3.14-3.14c-.7-.7-.7-1.834 0-2.534Z"
            fill={fill}
        />
    </svg>
);

export default Day;
